import OperatorStationPage from "../components/OperatorStationPage";

export default function IstasyonKesimPage() {
  return (
    <OperatorStationPage
      config={{
        role: "Kesim Operatörü",
        title: "Kesim Operatörü",
        subtitle: "Sadece kesime girmiş hayvanları kesim yapıldı durumuna taşır.",
        status: "entered",
        actionLabel: "Kesim Yapıldı",
        actionVariant: "warning",
        nextStatus: "cut",
        allowDirectDone: false,
        allowPackingZone: false,
      }}
    />
  );
}
